import styled from 'styled-components';

const StyledReferralForm = styled.form`
   display: flex;
   gap: 24px;
   flex-direction: column;
   width: 100%;
   height: 100%;
   max-width: 800px;
`;

export { StyledReferralForm };
